import { makeTermsAgreement } from 'src/main/factories/pages'

export default makeTermsAgreement
